import { PageHeader } from "../components/PageHeader";
import { ContactBlock, ServiceArea } from "../sections/HomeBlocks2";

export default function Contact() {
  return (
    <main>
      <PageHeader
       
        lines={["Tell us what", "you're building."]}
        sub="WhatsApp is the fastest way to reach us — but the form works just as well. Either way, you'll hear back from the people doing the work."
      />
      <ContactBlock chapter="01" />
      <ServiceArea chapter="02" />
    </main>
  );
}
